module.exports = __webpack_public_path__ + "img/Serbia.9a139a61.png";